import FJConstant from '../../constants/FJConstant.js';
import FJTextToMusic from '../../assets/svg/menu/text-to-music.svg?react';
import FJTextToMusicActive from '../../assets/svg/menu/text-to-music-active.svg?react';
import FJInstrumentalIcon from '../../assets/svg/menu/music-to-music.svg?react';
import FJInstrumentalActiveIcon from '../../assets/svg/menu/music-to-music-active.svg?react';
import FJSoundEffectIcon from '../../assets/svg/menu/sound-effects.svg?react';
import FJSoundEffectActiveIcon from '../../assets/svg/menu/sound-effects-active.svg?react';

const FJAIAudioGeneratorData = {
    MENU_LIST: [
        // {
        //     name: 'music',
        //     value: FJConstant.VOCAL,
        //     icon: FJMusicIcon,
        // },
        // {
        //     name: 'instrumental',
        //     value: FJConstant.INSTRUMENTAL,
        //     icon: FJInstrumentalIcon,
        // },
        {
            name: 'text-to-music',
            value: FJConstant.TEXT_TO_MUSIC,
            icon: FJTextToMusic,
            hoverIcon: FJTextToMusicActive,
        },
        {
            name: 'music-to-music',
            value: FJConstant.MUSIC_TO_MUSIC,
            icon: FJInstrumentalIcon,
            hoverIcon: FJInstrumentalActiveIcon,
        },
        {
            name: 'sound-effect',
            value: FJConstant.SOUND_EFFECT,
            icon: FJSoundEffectIcon,
            hoverIcon: FJSoundEffectActiveIcon,
        },
    ],
};

export default FJAIAudioGeneratorData;
export const MAX_PROMPT_LENGTH = 2000;
export const MAX_LYRICS_LENGTH = 3000;
